export default __webpack_public_path__ + "static/vanNuysPainting-640ef092c76981e2a04e7498bddc0735.svg";